import { ContentType, HttpClient, RequestParams } from '../http-client';

export class VesselManagement<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  createCompanyVessel = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  editCompanyVessel = ({ id, ...data }: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVessel = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselParam = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselProjectsById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/${id}/projects`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyAvailableVessel = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/assign`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselGroup = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselGroupById = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group/${data.query}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  createCompanyVesselGroup = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  editCompanyVesselGroup = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  assignVesselToGroup = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group/assign`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  removeVesselFromGroup = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/group/remove/${id}`,
      method: 'DELETE',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  createCompanyVesselRoute = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/route`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  editCompanyVesselRoute = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/route/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselRoute = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/route/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselProjectById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getVesselAvailableCrew = (
    query?: {
      rank?: string;
      vessel_id?: number;
      start_date?: string;
      end_date?: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/available/crew`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...(query && { query }),
      ...params,
    });

  getVesselAvailableCrewExtended = (
    query?: {
      search?: string;
      start_date?: string;
      end_date?: string;
      page?: number;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/available/crew/extended`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...(query && { query }),
      ...params,
    });

  assignCrewToVesselProjectRank = (
    id: number,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addNewCrewToVesselProjectRank = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCrewScheduleToProject = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/schedules`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCrewScheduleInProject = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/schedule/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  editCrewScheduleInProject = (
    id: number,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/schedule/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  deleteCrewScheduleInProject = (id: number, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/schedule/${id}`,
      method: 'DELETE',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCrewReplacementToProject = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/replacement`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  addCrewReplacementForCrewRank = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/replacement-for`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getProjectCrewChangePlanning = (
    id: string,
    params: RequestParams = {},
    download?: boolean
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/${id}/crew/planning`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...(download && { query: { excel: true } }),
      ...params,
    });

  assignCrewToSameRank = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/crew`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getVesselProjectReport = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/report`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  transferCrewVessel = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/vessel/projects/crew/transfer`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
